import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';

const NavBar = ({ user, onLogout }) => (
  <nav style={n.nav}>
    <div style={n.left}>
        <img src={require('../assets/logo.png')} alt="Logo" style={n.logoImg} />
        <span style={n.logoText}>ECG RHYTHM EXPERTS</span>
      </div>
    <div style={n.right}>
      <div style={n.userPill}>
        <div style={n.avatar}>{user.name?.charAt(0).toUpperCase()}</div>
        <div>
          <div style={n.userName}>{user.name}</div>
          <div style={n.userRole}>{user.role}</div>
        </div>
      </div>
      <button style={n.logoutBtn} onClick={onLogout}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="#64748b" strokeWidth="1.5" strokeLinecap="round"/>
          <polyline points="16 17 21 12 16 7" stroke="#64748b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="21" y1="12" x2="9" y2="12" stroke="#64748b" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        Sign out
      </button>
    </div>
  </nav>
);

const n = {
  nav: {
    height: '64px', background: 'white', borderBottom: '1px solid #e2e8f0',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 32px', position: 'sticky', top: 0, zIndex: 100,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  left: { display: 'flex', alignItems: 'center', gap: '10px' },
  logoIcon: {
    width: '34px', height: '34px', borderRadius: '8px',
    background: 'linear-gradient(135deg, #0ea5e9, #0284c7)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  logoText: { fontSize: '17px', fontWeight: '700', color: '#0f172a', letterSpacing: '-0.3px' },
  right: { display: 'flex', alignItems: 'center', gap: '16px' },
  userPill: { display: 'flex', alignItems: 'center', gap: '10px' },
  avatar: {
    width: '34px', height: '34px', borderRadius: '50%',
    background: 'linear-gradient(135deg, #0ea5e9, #0284c7)',
    color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '13px', fontWeight: '600',
  },
  userName: { fontSize: '13px', fontWeight: '600', color: '#0f172a' },
  userRole: { fontSize: '11px', color: '#94a3b8', textTransform: 'capitalize' },
  logoutBtn: {
    display: 'flex', alignItems: 'center', gap: '6px',
    padding: '8px 14px', background: 'transparent',
    border: '1px solid #e2e8f0', borderRadius: '8px',
    fontSize: '13px', color: '#64748b', cursor: 'pointer',
    transition: 'all 0.2s',
  },
  logoImg: { width: '34px', height: '34px', objectFit: 'contain', borderRadius: '6px' },

};

export default function Dashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [stats, setStats] = useState({ total: 0, pending: 0, uploaded: 0, ready: 0 });

  useEffect(() => {
    API.get('/cases').then(res => {
      const cases = res.data;
      setStats({
        total: cases.length,
        pending: cases.filter(c => c.status === 'pending_upload').length,
        uploaded: cases.filter(c => c.status === 'uploaded').length,
        ready: cases.filter(c => c.status === 'report_ready').length,
      });
    }).catch(() => {});
  }, []);

  const handleLogout = () => { localStorage.clear(); navigate('/login'); };

  const cards = [
    {
      icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 11l3 3L22 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>,
      title: 'All Cases', desc: 'View and manage patient cases', color: '#0ea5e9', path: '/cases', roles: ['admin','analyst','clinic'],
    },
    {
      icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><line x1="12" y1="5" x2="12" y2="19" stroke="white" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="white" strokeWidth="2.5" strokeLinecap="round"/></svg>,
      title: 'New Case', desc: 'Register a new patient', color: '#10b981', path: '/cases/new', roles: ['admin','clinic'],
    },
    {
      icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="white" strokeWidth="2" strokeLinecap="round"/><circle cx="9" cy="7" r="4" stroke="white" strokeWidth="2"/><path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="white" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>,
      title: 'Users', desc: 'Manage accounts & clinics', color: '#8b5cf6', path: '/users', roles: ['admin'],
    },
    {
      icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="2" y="3" width="20" height="14" rx="2" stroke="white" strokeWidth="2"/><line x1="8" y1="21" x2="16" y2="21" stroke="white" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="17" x2="12" y2="21" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>,
      title: 'Inventory', desc: 'Track holter patch stock', color: '#f59e0b', path: '/inventory', roles: ['admin'],
    },
  ].filter(c => c.roles.includes(user.role));

  const statCards = [
    { label: 'Total Cases', value: stats.total, color: '#0ea5e9', bg: '#e0f2fe',
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#0ea5e9" strokeWidth="1.5"/><polyline points="14 2 14 8 20 8" stroke="#0ea5e9" strokeWidth="1.5"/></svg> },
    { label: 'Pending Upload', value: stats.pending, color: '#f59e0b', bg: '#fef3c7',
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="1.5"/><polyline points="12 6 12 12 16 14" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/></svg> },
    { label: 'Under Review', value: stats.uploaded, color: '#8b5cf6', bg: '#ede9fe',
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="#8b5cf6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg> },
    { label: 'Reports Ready', value: stats.ready, color: '#10b981', bg: '#d1fae5',
      icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="#10b981" strokeWidth="1.5" strokeLinecap="round"/><polyline points="22 4 12 14.01 9 11.01" stroke="#10b981" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg> },
  ];

  return (
    <div style={d.page}>
      <NavBar user={user} onLogout={handleLogout} />
      <main style={d.main}>
        {/* Hero greeting */}
        <div style={d.hero} className="animate-fadeUp">
          <div>
            <h1 style={d.heroTitle}>Good {getGreeting()}, {user.name?.split(' ')[0]}</h1>
            <p style={d.heroSub}>Here's what's happening with your cases today.</p>
          </div>
          <div style={d.heroBadge}>
            <div style={d.heroBadgeDot} />
            System operational
          </div>
        </div>

        {/* Stat cards */}
        <div style={d.statsGrid}>
          {statCards.map((sc, i) => (
            <div key={sc.label} style={d.statCard} className={`animate-fadeUp delay-${i+1}`}>
              <div style={{ ...d.statIcon, background: sc.bg }}>{sc.icon}</div>
              <div style={d.statValue}>{sc.value}</div>
              <div style={d.statLabel}>{sc.label}</div>
              <div style={{ ...d.statBar, '--color': sc.color }}>
                <div style={{ ...d.statBarFill, background: sc.color, width: `${Math.min((sc.value / Math.max(stats.total, 1)) * 100, 100)}%` }} />
              </div>
            </div>
          ))}
        </div>

        {/* Nav cards */}
        <h2 style={d.sectionTitle} className="animate-fadeUp">Quick actions</h2>
        <div style={d.navGrid}>
          {cards.map((card, i) => (
            <div
              key={card.title}
              style={d.navCard}
              className={`animate-fadeUp delay-${i+1}`}
              onClick={() => navigate(card.path)}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(0,0,0,0.12)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)'; }}
            >
              <div style={{ ...d.navIcon, background: `linear-gradient(135deg, ${card.color}, ${card.color}cc)` }}>
                {card.icon}
              </div>
              <h3 style={d.navTitle}>{card.title}</h3>
              <p style={d.navDesc}>{card.desc}</p>
              <div style={d.navArrow}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="m9 18 6-6-6-6" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return 'morning';
  if (h < 17) return 'afternoon';
  return 'evening';
}

const d = {
  page: { minHeight: '100vh', background: '#f8fafc' },
  main: { maxWidth: '1200px', margin: '0 auto', padding: '40px 32px' },
  hero: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' },
  heroTitle: { fontSize: '28px', fontWeight: '700', color: '#0f172a', letterSpacing: '-0.5px', marginBottom: '6px' },
  heroSub: { fontSize: '14px', color: '#64748b' },
  heroBadge: {
    display: 'flex', alignItems: 'center', gap: '8px',
    padding: '8px 16px', background: '#f0fdf4',
    border: '1px solid #bbf7d0', borderRadius: '20px',
    fontSize: '13px', color: '#16a34a', fontWeight: '500',
  },
  heroBadgeDot: { width: '7px', height: '7px', borderRadius: '50%', background: '#10b981', animation: 'pulse-ring 2s infinite' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '40px' },
  statCard: {
    background: 'white', borderRadius: '14px', padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)', border: '1px solid #f1f5f9',
  },
  statIcon: { width: '36px', height: '36px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '14px' },
  statValue: { fontSize: '32px', fontWeight: '700', color: '#0f172a', letterSpacing: '-1px', lineHeight: 1 },
  statLabel: { fontSize: '13px', color: '#64748b', marginTop: '4px', marginBottom: '16px' },
  statBar: { height: '3px', background: '#f1f5f9', borderRadius: '2px', overflow: 'hidden' },
  statBarFill: { height: '100%', borderRadius: '2px', transition: 'width 1s ease' },
  sectionTitle: { fontSize: '16px', fontWeight: '600', color: '#0f172a', marginBottom: '16px', letterSpacing: '-0.2px' },
  navGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '16px' },
  navCard: {
    background: 'white', borderRadius: '16px', padding: '24px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9',
    cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4,0,0.2,1)',
    position: 'relative', overflow: 'hidden',
  },
  navIcon: { width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' },
  navTitle: { fontSize: '16px', fontWeight: '600', color: '#0f172a', marginBottom: '6px', letterSpacing: '-0.2px' },
  navDesc: { fontSize: '13px', color: '#64748b', lineHeight: '1.5' },
  navArrow: { position: 'absolute', top: '24px', right: '24px' },
};